import grapesjs from "grapesjs";
import customCodePlugin from "../../../../utils/custom-code-grapejs/index.ts";
import sendpadForm from "../../../../utils/sendpadForm/index.ts";
import gjsTabs from "../../../../utils/grapeJsTabs/index";
import gjsTooltip from "grapesjs-tooltip";
import gjsImageEditor from "../../../../utils/grapeJsImageEditor/index.ts";
import gjsp from "grapesjs-preset-webpage";
import gjsModal from "../../../../utils/grapejsModal/index.ts";
import gjsAccordian from "grapesjs-accordion";
import alignment from "../customstyles/alignment.js";
import { toast } from "react-toastify";
import server from "../../../../apis/server.js";
import tiny_mce from "../../../../tiny_mce/index.js";
import placeholder from "../../../../utils/grapesJSPlaceholder/index.js";
import replaceTextViewComponent from "../../../../utils/single-click-tinymce/index.js";
import myNewComponentTypes from "../../../../components/grapejscomponents/index.ts";
import resizing from "../customstyles/resizing.js";

const updatePage = `${process.env.REACT_APP_API_URL}/page/update`;

export function Initialize(state, setLoading, editorpage) {
  const editor = grapesjs.init({
    allowScripts: 1,

    container: "#gjs",
    height: "100vh",
    fromElement: true,
    styleManager: {
      sectors: [
        // {
        //     name: "Resizing",
        //     properties: [
        //       {
        //         type: "my-custom",
        //          property: "text-align",
        //         default: "center",
        //         // min: 10,
        //         // max: 70,
        //       },
        //     ],
        //   },
        {
          name: "Dimension",
          open: false,
          properties: [
            "width",
            "height",
            "max-width",
            "min-height",
            "margin",
            "padding",
          ],
        },
        {
          name: "Flex",
          open: false,
          properties: [
            "flex-direction",
            "flex-wrap",
            "justify-content",
            "align-items",
            "align-content",
            "order",
            "flex-basis",
            "flex-grow",
            "flex-shrink",
            "align-self",
          ],
        },
        {
          name: "Alignment",
          properties: [
            {
              type: "my-custom-prop",
              property: "text-align",
              default: "center",
              // min: 10,
              // max: 70,
            },
          ],
        },
        
      ],
    },
    canvasCss: `
        gjs-plh-image{
            color:#3b97e3;
        }
        .image-pl-svg{
            fill:#3b97e3;
        }
        .gjs-plh-image[data-gjs-type="image"]{
            width:30%;
            height:30%;
            background-color:transparent;
            outline:none;

        }
      
        div.navbar[data-gjs="navbar"]{
            max-width:100%;

        }
        div.navbar[data-gjs="navbar"]>.navbar-container{
            max-width:1140px;
        }
       

        .gjs-selected{
            outline: 4px solid #3b97e3 !important;
            outline-offset: -2px;
        }
        img.gjs-selected{
            z-index: 90000001;
            position: relative;
        }
        .gjs-higlight-backdrop-container{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #151515;
            z-index:9000000;
            opacity:0;
            transition: opacity 0.3s ease-in
        }
        .gjs-higlight-backdrop-container.active{
            opacity:0.3;
        }

        .form-group {
            width: 100%;
        }

        .form-group {
            width: 100%;
        }
        [data-gjs-type="grid-item"]:empty {
            overflow: hidden;
            text-decoration: none;
            padding: 5px;
            display: flow;
    width: 99%;
        }
        .cell{
          height: auto !important;
        }
        [data-gjs-type="grid-item"]:empty:before {
            background-color: #ddd;
            color: #000;
            font-size: 16px;
            font-weight: bold;
            height: 75px;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 50px;
            padding: 0 10px;
            opacity: 0.3;
            border-radius: 3px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            content: "Column";
        }   
        .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}

      `,

    protectedCss: `body{margin:0; }.row{margin:0 auto;box-sizing:border-box;} div.row>div.cell:first-child{
            padding-right:6px;
            padding-left:0px;
        }div.row>div.cell:last-child{
            padding-left:6px;
            padding-right:0px;
        }div.cell{
            padding-left:3px;
            padding-right:3px;
        } 
        .cell{
          height: auto !important;
        }
        .right-space-issue {
  margin-right: 3rem;
} @media (max-width: 768px){       .right-space-issue {
  margin-right: 0;
}}
        .openModalBtn{border: none; cursor: pointer; background-color: #f0c864; color: #000;font-weight: 700; line-height: 1.66; font-size: 20px; border: 0; border-radius: 30px; display: inline-block; padding: 8px 20px; width: auto; height: 48px;} .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;} a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}img{max-width:100%;height:auto}.cell {height: auto;vertical-align: top;}.cke_editable p{display: block; margin-block-start: 0em !important; margin-block-end: 0em !important;margin-inline-start: 0em !important;margin-inline-end: 0em !important;}table.grid-item-card tbody tr td {background: none !important;}.list-item tr td {background: none !important;}.form-group{ float:none; flex-direction:column; border:0 solid black; display:flex; } .label{ margin:0 0 15px 0; font-family:Arial, Helvetica, sans-serif; font-size:14px; font-weight:600; } .form{ display:flex; flex-direction:column; padding:50px 50px 50px 50px; border:1px solid #6c7978; margin:10px 10px 10px 10px; background-color:#f5f5f5; } .input{ height:40px; width:auto; margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px; } textarea { margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px;} .button{ height:42px; border-radius:7px; margin:10px 0 0 0; border:1px solid #7e7e7e; font-family:Arial Black, Gadget, sans-serif; font-size:14px; font-weight:600; color:#ffffff; background-color:#000000; } .form-group:nth-child(3) {display: none;} .form-group:nth-child(4) {display: none;}.form-group:has(> .checkbox) { flex-direction:row;align-items: start; }input.checkbox {margin-left: 25px;}label.checkbox-label {margin-left: 5px;} @media (max-width: 992px){ .form{ padding:20px 20px 20px 20px; } }@media (max-width:768px){.cell{width:100%;}div.row>div.cell:first-child{
            padding-right:0px;
            padding-left:0px;
        }div.row>div.cell:last-child{
            padding-left:0px;
            padding-right:0px;
        } }
        .form-group {
            width: 100%;
        }
        .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
       ${
         state?.is_from_template == false
           ? ".modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;}a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}.row{padding:0 !important;}p{padding:0 !important; margin:0 !important;}h1{padding:0 !important; margin:0 !important;}h4{padding:0; margin:0;}@media(max-width:768px){.cell{display: block !important; width: 100% !important; height: auto !important; padding: 0 !important; min-height: 75px !important; }}.accordion>p{display:inline-block;}"
           : ""
       }`,
    width: "100%",
    plugins: [
      gjsAccordian,
      gjsImageEditor,
      gjsp,
      gjsTabs,
      gjsTooltip,
      // resizing,
      gjsModal,
      alignment,
      sendpadForm,
      customCodePlugin,
      tiny_mce,
      placeholder,
      myNewComponentTypes,
    ],
    pluginsOpts: {
      [gjsp]: {
        blocks: [],
        showStylesOnChange: false,
        // options
      },

      customCodePlugin: {
        placeholderScript: true,
        blockCustomCode: { label: "Custom" },
        // options
      },
      [tiny_mce]: {
        "tinymce-module": "/tinymce/tinymce.min.js",
        inline: ["span", "a", "button"],
        inline_toolbar: [
          "bold italic underline strikethrough forecolor backcolor",
          "fontfamily fontsize",
        ],
        toolbar: [
          "bold italic underline strikethrough link fontfamily fontsize outdent indent",
          "blocks forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist",
        ],
        plugins: ["link", "lists", "autolink"],
      },
      [placeholder]: {
        dragDefault: [""],
        dragClasses: ["gjs-selected", "gjs-freezed", "animation"],
        animation: ["none"], // animation1 / animation2 / animation3 / animation4 / animation5 / none
      },
      // sendpadForm: {
      //     placeholderScript	:true,
      //     blockCustomCode:{ label: 'Sendpad Form'}
      //   // options
      // }
    },
    clearOnRender: true,
    storageManager: {
      type: "remote",
      autosave: true,
      stepsBeforeSave: 1,
      contentTypeJson: true,
      storeComponents: true,
      storeStyles: true,
      storeHtml: true,
      storeCss: true,
      options: {
        remote: {
          contentTypeJson: true,

          urlStore: updatePage,
          // The `remote` storage uses the POST method when stores data

          fetchOptions: (opts) =>
            opts.method === "POST" ? { method: "POST" } : {},

          onLoad: (data) => JSON.parse(data?.data?.data?.draft_body),
        },
      },
    },

    assetManager: {
      autoAdd: 1,
      // assets: images,
      upload: 0,
      storeOnChange: true,
      storeAfterUpload: true,

      // uploadName: 'files',
      uploadText: "Drop or click to upload",
      // upload: '<?php echo $uploadUrl;?>',
      // addBtnText: '<?php echo $this->translate("Aggiungi immagine");?>',
      uploadFile: async function (e) {
        // setUpdate('ccc')

        setLoading(true);
        // const {data} = await server.get(`${getPage}`);

        var files = e?.dataTransfer
          ? e?.dataTransfer?.files?.[0]
          : e?.target?.files?.[0];

        let fileSizeInBytes = files?.size;
        let fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert bytes to megabytes

        if (fileSizeInMB > 2) {
          // File size is greater than 2 MB
          toast("Please upload a file smaller than 2 MB.");
          setLoading(false);

          return;
        }

        var formData = new FormData();
        formData.append("file", files);
        formData.append("page_id", editorpage);

        try {
          const { data } = await server.post(`media/upload`, formData);
          setLoading(false);

          if (data?.status) {
            editor.AssetManager.add(data?.data?.upload_url);

            // isLoading(true)
            // router.push(`/pages/editor/${data?.data?.page_id}`)
          }
          // setProduct(data);
          // setLoading(false);
        } catch (e) {
          setLoading(false);
          if (e.response?.data?.status === false) {
            if (e.response?.data.errors_array?.[0]) {
              toast(e.response?.data.errors_array?.[0], "error");
            } else {
              toast(e.response?.data?.message, "error");
            }
            //  setError(e.response?.data.errors?.title[0])
          }
        }
      },
    },
    deviceManager: {
      devices: [
        {
          id: "desktop",
          name: "Desktop",
          width: "",
        },
        {
          id: "tablet",
          name: "Tablet",
          width: "768px",
          widthMedia: "992px",
        },
        {
          id: "mobilePortrait",
          name: "Mobile portrait",
          title: "Mobile portrait",
          width: "320px",
          widthMedia: "575px",
        },
      ],
    },
    //  pluginsOpts: {
    //     'grapesjs-preset-webpage': {
    //         blocksBasicOpts: {
    //             blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
    //             flexGrid: 1,
    //         },
    //         blocks: ['link-block', 'quote', 'text-basic'],
    //     },
    // },
  });

  // editor.Commands.extend('select-comp', {
  //     onClick: (e) => {
  //         const pn = editor.Panels;
  //         const osm = 'open-sm';
  //         const openSmBtn = pn.getButton('views', osm);

  //         openSmBtn && openSmBtn.set('active', 1);

  //     },
  //     onHovered(em, component) {
  //         if (component && component.getEl()){
  //            if (component.attributes.type === 'wrapper'){
  //             return ;
  //            }
  //         }
  //         if (component && component.getEl()) {
  //             if (!editor.getSelected()) {
  //                 editor.select(component);

  //             } else if (editor.getSelected().getId() !== component.getId()) {
  //                 editor.select(component);
  //             }
  //         }
  //     },
  // });

  // var pn = editor.Panels;
  // pn.removeButton('views', 'open-tm');

  // editor.on('load', function() {
  //   var $ = grapesjs.$;
  //   var traitsSector = $('<div class="gjs-sm-sector no-select">' +
  //   '<div class="gjs-sm-sector-title"><span class="icon-settings fa fa-cog"></span> <span class="gjs-sm-sector-label">Settings</span></div>' +
  //   '<div class="gjs-sm-properties" style="display: none;"></div></div>');
  //   debugger
  //   var traitsProps = traitsSector.find('.gjs-sm-properties');
  //   traitsProps.append($('.gjs-traits-cs')[0]);
  //   $('.gjs-sm-sectors').before(traitsSector);
  //   traitsSector.find('.gjs-sm-sector-title').on('click', function () {
  //       var traitStyle = traitsProps.get(0).style;
  //       var hidden = traitStyle.display == 'none';
  //       if (hidden) {
  //           traitStyle.display = 'block';
  //       } else {
  //           traitStyle.display = 'none';
  //       }
  //   });
  // });

  alignment(editor);
  //  resizing(editor);
  replaceTextViewComponent(editor);
  return editor;
}
